import { render, staticRenderFns } from "./ItemTickets.vue?vue&type=template&id=0d0fbf9b"
import script from "./ItemTickets.vue?vue&type=script&lang=js"
export * from "./ItemTickets.vue?vue&type=script&lang=js"
import style0 from "./ItemTickets.vue?vue&type=style&index=0&id=0d0fbf9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports